import { takeLatest } from "redux-saga/effects";
import confirmVendorsWorker from "./confirmVendorsWorker";
import getVendorsWorker from "./getVendorsWorker";

export function* vendorsWatcher() {
    yield takeLatest("vendors/getVendorsFetch", getVendorsWorker);
    yield takeLatest("vendors/confirmVendorFetch", confirmVendorsWorker);
}